import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function OrderReducer(state = initialState.order, action: any) {
  switch (action.type) {
    case types.SAVE_ORDER_SUCCESS:
      return action.order;
    default:
      return state;
  }
}
